import React, { FC } from "react";
import { Tooltip } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const GetDisplayName: FC<{ firstName?: string; lastName?: string }> = ({ firstName, lastName }) => {
    const intl = useIntl();

    const missingBothNames = intl.formatMessage({ id: "missingBothNames" });
    const missingFirstName = intl.formatMessage({ id: "missingFirstName" });
    const missingLastName = intl.formatMessage({ id: "missingLastName" });

    const wrapWithTooltip = (name: string, tooltipMessage: string) => (
        <span>
            {name}{" "}
            <Tooltip title={tooltipMessage}>
                <ExclamationCircleOutlined style={{ color: "orange", marginLeft: "5px" }} />
            </Tooltip>
        </span>
    );

    if (firstName && lastName) {
        return <>{`${firstName} ${lastName}`}</>;
    }

    if (!firstName && lastName) {
        return wrapWithTooltip(lastName, missingFirstName);
    }

    if (firstName && !lastName) {
        return wrapWithTooltip(firstName, missingLastName);
    }

    return (
        <Tooltip title={missingBothNames}>
            <ExclamationCircleOutlined style={{ color: "orange" }} />
        </Tooltip>
    );
};

export default GetDisplayName;
